import { render } from "./EditMenu.vue?vue&type=template&id=5d3b586d"
import script from "./EditMenu.vue?vue&type=script&lang=js"
export * from "./EditMenu.vue?vue&type=script&lang=js"

import "./EditMenu.vue?vue&type=style&index=0&id=5d3b586d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__